import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.CompanyEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.CompanyList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.CompanyCreate })));
const BusinessApplicationEdit = lazy(() => import("./BusinessApplication/BasicInfo").then(m => ({ default: m.BasicInfo })));
const BusinessApplicationRedirect = lazy(() => import("./BusinessApplication/Redirect").then(m => ({ default: m.BusinessApplicationRedirect })));

export default {
  edit,
  list,
  create,
  BusinessApplicationEdit,
  BusinessApplicationRedirect,
};
